export enum UserType {
    ADMIN, STAFF, DEVELOPER
}